// src/config/db_config.js

// Are we inside a React Native WebView?
const isRunningInWebView =
  typeof window !== "undefined" && window.ReactNativeWebView !== undefined;

// Current page host (127.0.0.1 / localhost / 10.0.2.2 / domain)
const pageHost =
  (typeof window !== "undefined" &&
    window.location &&
    window.location.hostname) ||
  "localhost";

/**
 * Resolve the API base:
 * - In local/dev (localhost/127.0.0.1/10.0.2.2 **or** inside RN WebView) use http://127.0.0.1:3001
 *   (for Android emulator you can change to 10.0.2.2 if needed).
 * - In production (real domain) use relative base "".
 */
function resolveEndpoint() {
  const isLocal =
    pageHost === "localhost" ||
    pageHost === "127.0.0.1" ||
    pageHost === "10.0.2.2" ||
    isRunningInWebView;

  if (isLocal) {
    // iOS Simulator & desktop both happily reach your Mac at 127.0.0.1
    return "http://127.0.0.1:3001";
    // If you test Android emulator’s chrome, swap to:
    // return "http://10.0.2.2:3001";
  }
  return ""; // production: same-origin
}

export const API_BASE = resolveEndpoint();
const endpoint = API_BASE;

export const calls = {
  endpoint: endpoint,
  signIn: endpoint + "/sign-in",
  nativeSession: endpoint + "/native-session",
  session: endpoint + "/session",
  signInAs: endpoint + "/signInAs",
  googleLogin: endpoint + "/google-login",
  appleLogin: endpoint + "/apple-sign-in",
  signUp: endpoint + "/sign-up",
  forgotPassword: endpoint + "/forgot-password",
  changePassword: endpoint + "/change-password",
  getData: endpoint + "/get-data",
  resetPassword: endpoint + "/reset-password",
  getResetValidity: endpoint + "/get-reset-validity",
  getQuestions: endpoint + "/get-questions?answers=true",
  getQuestionsOnly: endpoint + "/get-questions?answers=false",
  getQuestionsBySubject: endpoint + "/get-questions-by-subject",
  getQuestionsByChapterId: endpoint + "/get-questions-by-chapter-id",
  removeQuestion: endpoint + "/remove-question",
  removeUserToken: endpoint + "/remove-user-token",
  generateQuiz: endpoint + "/generate-quiz",
  getQuizResults: endpoint + "/get-quiz-results",
  answerQuestion: endpoint + "/answer-question",
  updateAnswer: endpoint + "/update-answer",
  createQuestion: endpoint + "/create-question",
  updateQuestion: endpoint + "/update-question",
  tempZip: endpoint + "/tempZip",
  addNewSchool: endpoint + "/add-new-school",
  getUserSchools: endpoint + "/get-user-schools",
  getClasses: endpoint + "/get-classes",
  getAllClasses: endpoint + "/get-all-classes",
  getChaptersByClassId: endpoint + "/get-chapters-by-class-id",
  getClassesByUser: endpoint + "/get-classes-by-user",
  getUserHasClasses: endpoint + "/get-user-has-classes",
  getSubjects: endpoint + "/get-subjects",
  updateUserHasClass: endpoint + "/update-user-has-class",
  getUserData: endpoint + "/get-user-data",
  updateProfile: endpoint + "/update-profile",
  updateProfilePicture: endpoint + "/update-profile-picture",
  saveChatPicture: endpoint + "/save-chat-picture",
  startQuizResults: endpoint + "/start-quiz-results",
  submitQuizResults: endpoint + "/submit-quiz-results",
  getChagptResponse: endpoint + "/get-chatgpt-response",
  submitExamImage: endpoint + "/submit-exam-image",
  submitQuizAudio: endpoint + "/submit-quiz-audio",
  submitCurriculumImages: endpoint + "/submit-curriculum-images",
  submitCurriculumAnswersImages: endpoint + "/submit-curriculum-answers-images",
  submitExam: endpoint + "/submit-exam",
  getExams: endpoint + "/get-exams",
  getUsers: endpoint + "/get-users",
  getExamsByName: endpoint + "/get-exams-by-name",
  getExamsMarked: endpoint + "/get-exams-marked",
  getExamsNotMarked: endpoint + "/get-exams-not-marked",
  setExamTimeStarted: endpoint + "/set-exam-time-started",
  setExamLog: endpoint + "/set-exam-log",
  getExamLogs: endpoint + "/get-exam-logs",
  setExamScore: endpoint + "/set-exam-score",
  adminSubmitExam: endpoint + "/admin-submit-exam",
  adminSubmitExamImage: endpoint + "/admin-submit-exam-images",
  studentSubmitExamImages: endpoint + "/student-submit-exam-images",
  adminSubmitQuizImages: endpoint + "/admin-submit-quiz-images",
  submitAnnouncementImages: endpoint + "/submit-announcement-images",
  getExamTimeStarted: endpoint + "/get-exam-time-started",
  getExamsSubmitted: endpoint + "/get-exams-submitted",
  getExamResultsById: endpoint + "/get-exam-results-by-id",
  getExamById: endpoint + "/get-exam-by-id",
  getEndpointLink: endpoint + "/get-endpoint-link",
  deleteExam: endpoint + "/delete-exam",
  adminEditExam: endpoint + "/admin-edit-exam",
  insertLog: endpoint + "/insert-log",
  getQuizAverageByChapter: endpoint + "/get-quiz-average-by-chapter",
  getQuizWeekAverage: endpoint + "/get-quiz-week-average",
  getLogoLink: endpoint + "/get-logo-link",
  getSettingValue: endpoint + "/get-setting-value",
  getEnvironment: endpoint + "/get-env",
  sendInvoice: endpoint + "/send-invoice",
  sendReceipt: endpoint + "/send-receipt",
  cancelReceipt: endpoint + "/cancel-receipt",
  saveGeneratedEvents: endpoint + "/save-generated-events",
  generateEvents: endpoint + "/generate-events",

  // stats
  getQuizStats: endpoint + "/get-quiz-stats",
  getExamStats: endpoint + "/get-exam-stats",
  getExamCount: endpoint + "/get-exam-count",
  getUsersCount: endpoint + "/get-users-count",
  getQuizCount: endpoint + "/get-quiz-count",
  getExamScoresLmh: endpoint + "/get-exam-scores-lmh",
  getExamStudentStats: endpoint + "/get-exam-student-stats",
  getExamStudentCounts: endpoint + "/get-exam-student-counts",
  getExamStudentCountsLatest: endpoint + "/get-exam-student-counts-latest",
  getExamsAverages: endpoint + "/get-exams-averages",
  getQuizAverages: endpoint + "/get-quiz-averages",

  // user stats
  getUserQuizAveragePerMonth: endpoint + "/get-user-quiz-average-per-month",
  getUserQuizAverage: endpoint + "/get-user-quiz-average",
  getUserQuizScoresLmh: endpoint + "/get-user-quiz-scores-lmh",
  getUserExamStats: endpoint + "/get-user-exam-stats",
  getUserExamTimes: endpoint + "/get-user-exam-times",
  getUserOverallGrade: endpoint + "/get-user-overall-grade",
};
